"use client";

import {
  Activity,
  ChromeIcon,
  Copy,
  Fingerprint,
  Flame,
  Gift,
  Globe,
  LocateFixed,
  Lock,
  MapPin,
  Monitor,
  Search,
  ShieldCheck,
  Smartphone,
  Terminal,
  Waypoints,
  Zap,
} from "@/components/icons";
import {
  AVAILABLE_WEB_TOOLS_COPY,
  COMING_SOON_COPY,
  EXTENSIONS_COPY,
  PRODUCT_PAIRINGS,
  WHY_TOOLS_COPY,
} from "./content";
import type {
  ExtensionEntry,
  IconComponent,
  ProductPairEntry,
  ToolEntry,
  WhyToolEntry,
} from "./types";

const AVAILABLE_ICONS: Record<string, IconComponent> = {
  chrome: ChromeIcon,
  firefox: Flame,
  mcp: Terminal,
  fingerprint: Fingerprint,
  "webrtc-leak": Waypoints,
  "user-agent": Monitor,
  "ip-checker": Search,
};

const TOOL_ICONS: Record<string, IconComponent> = {
  "proxy-checker": ShieldCheck,
  "ip-checker": Search,
  "ip-lookup": MapPin,
  "user-agent": Monitor,
  fingerprint: Fingerprint,
  "my-location": LocateFixed,
  "proxy-bandwidth-checker": Zap,
};

const WHY_ICONS: Record<string, IconComponent> = {
  free: Gift,
  private: Lock,
  browser: Globe,
  accurate: ShieldCheck,
  realtime: Activity,
  export: Copy,
};

export const AVAILABLE_TOOLS: ExtensionEntry[] = [
  ...EXTENSIONS_COPY,
  ...AVAILABLE_WEB_TOOLS_COPY,
].map((entry) => ({
  ...entry,
  icon: AVAILABLE_ICONS[entry.slug],
}));

export const COMING_SOON_TOOLS: ToolEntry[] = COMING_SOON_COPY.map((entry) => ({
  ...entry,
  icon: TOOL_ICONS[entry.slug],
}));

export const WHY_TOOLS: WhyToolEntry[] = WHY_TOOLS_COPY.map((entry) => ({
  ...entry,
  icon: WHY_ICONS[entry.slug],
}));

const PRODUCT_ICONS: Record<string, IconComponent> = {
  mobile: Smartphone,
  residential: Globe,
};

export const PRODUCT_PAIRS: ProductPairEntry[] = PRODUCT_PAIRINGS.map((entry) => ({
  ...entry,
  icon: PRODUCT_ICONS[entry.slug],
}));
